import React from 'react';
import './_index.scss';
import { Tag } from '@carbon/react';
import PanelWrapper from "../PanelWrapper";
import NoDataPanel from "../NoDataPanel";

const Marker = ({ chart }) => {
    const getMarkerValue = (data) => {
        if (!data || data.length === 0) return null;
        const firstItem = data[0];
        const key = Object.keys(firstItem)[0];
        return firstItem[key];
    };

    const formatMarkerValue = (value) => {
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value)) {
            const datePart = value.split('T')[0];
            const [year, month, day] = datePart.split('-');
            value = `${day}/${month}/${year}`;
        }
        if (typeof value !== 'number') return value;
        return Number(value.toFixed(2));
    };
    
    return (
        <PanelWrapper 
            panel={chart}
            customNoDataRender={() => <NoDataPanel panel={{...chart, description: ""}} />}
        >
            {(panelData) => {
                const markerValue = getMarkerValue(panelData);
                
                return (
                    <div className="marker_container">
                        <div className="marker_value">
                            {formatMarkerValue(markerValue)}
                        </div>
                        <Tag className="tag">{chart.title}</Tag>
                    </div>
                );
            }}
        </PanelWrapper>
    );
};

export default React.memo(Marker)